import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// STYLES
import { StyledDialog } from './styles';

const successDialogBg = getS3ImageUrl('/create-acc-dialog-bg-2.jpg');

const DialogSuccess = ({ data, onGotItClick, promoCode, ...props }) => {
  const [t] = useTranslation();
  const { app } = data;

  return (
    <StyledDialog
      image={
        <>
          <img src={successDialogBg} alt="success-bg" />
          {!!app?.thumbnail && (
            <div className="dialog-cta__app-logo">
              <img src={app.thumbnail} alt={app.name} />
            </div>
          )}
        </>
      }
      title={t('subscription.promocode.successDialog.title')}
      subtitle={t('subscription.promocode.successDialog.subtitle', { code: promoCode })}
      subtitleProps={{
        className: 'p3 m-b-25',
      }}
      hideConfirmButton
      hideCancelButton
      maxWidth="md"
      {...props}
    >
      <div className="dialog-cta__inner-content">
        <Button onClick={onGotItClick} fullWidth color="primary">
          {t('buttons.gotIt')}
        </Button>
      </div>
    </StyledDialog>
  );
};

DialogSuccess.defaultProps = {
  onGotItClick: () => {},
};

DialogSuccess.propTypes = {
  data: PropTypes.object,
  onGotItClick: PropTypes.func,
  promoCode: PropTypes.string,
};

export default React.memo(DialogSuccess);
